import { useAuthStore } from '@/store/auth'
import { Navigate } from 'react-router-dom'

/**
 * Route guard that only allows users with globalRole 'admin' or 'superadmin'.
 * Redirects non-admin users to the dashboard.
 */
export function AdminGuard({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user)
  const globalRole = user?.globalRole

  if (globalRole !== 'admin' && globalRole !== 'superadmin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

/** Hook to check if the current user is an admin */
export function useIsAdmin(): boolean {
  const globalRole = useAuthStore((s) => s.user?.globalRole)
  return globalRole === 'admin' || globalRole === 'superadmin'
}
